module.exports = __webpack_public_path__ + "static/media/7.15cf85b0.webp";